import { render } from "./PrescriberOnboarding.vue?vue&type=template&id=5c9a3516"
import script from "./PrescriberOnboarding.vue?vue&type=script&lang=js"
export * from "./PrescriberOnboarding.vue?vue&type=script&lang=js"

import "./PrescriberOnboarding.vue?vue&type=style&index=0&id=5c9a3516&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__